import { strings } from '@/shared/strings';
import { EmptyState } from '@/ui/feedback/EmptyState';
import { LockIcon } from '@/ui/icons';
import styles from './AccessNotice.module.css';

/**
 * A screen its reader holds and cannot use, said in place of the screen. The
 * lab's request of 11 October 2026.
 *
 * A screen and the permission to do its work are two boxes of the matrix, and
 * one can be ticked without the other. Users given without "Manage users &
 * permissions" opened on an empty list for good, and Payments without "Mark
 * paid" on four blank totals. This says what is missing and who can give it,
 * and asks the server for nothing it would refuse. The reason is the domain's,
 * `screenClosedReason`.
 */
export function ScreenClosed({ reason }: { reason: string }) {
  return (
    <div data-testid="screen-closed">
      <EmptyState icon={<LockIcon />} heading={strings.access.screenClosed} detail={reason} />
    </div>
  );
}

/**
 * A screen its reader may read and not change, said above it: Settings without
 * "Manage users & permissions", Final Check without "Pass / fail Final Check".
 * The screen is drawn as it is; the server refuses a change, in words. The
 * reason is the domain's, `screenReadOnlyReason`.
 */
export function ScreenReadOnly({ reason }: { reason: string }) {
  return (
    <p className={styles.readOnly} role="note" data-testid="screen-read-only">
      <LockIcon size={15} />
      <span>{reason}</span>
    </p>
  );
}
